export default "__VITE_ASSET__CmWYRQS9__"